import { createContext, useContext, useState } from 'react';
import FullPageLoader from '../Component/FullPageLoader';

const LoaderContext = createContext();

export const LoaderProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <LoaderContext.Provider value={{ isLoading, setIsLoading }}>
      {children}
      {isLoading && <FullPageLoader />}
    </LoaderContext.Provider>
  );
};

export const useLoader = () => useContext(LoaderContext);
